import React from "react";
import { Routes, Route } from "react-router-dom";
import BannersAndPosts from "../screens/BannersAndPosts/BannersAndPosts";
import Promo from "../screens/BannersAndPosts/Promo/Promo";
import Slider from "../screens/BannersAndPosts/Slider/Slider";
import IgPosts from "../screens/BannersAndPosts/IgPosts/IgPosts";
import NotFound from "../screens/NotFound";

const BannersAndPostsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<BannersAndPosts />} />
      <Route path="/promo" element={<Promo />} />
      <Route path="/slider" element={<Slider />} />
      <Route path="/igPosts" element={<IgPosts />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default BannersAndPostsRoutes;
